import { render, staticRenderFns } from "./BenefitsOfRegistration.vue?vue&type=template&id=2dcb6e96&scoped=true&"
import script from "./BenefitsOfRegistration.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BenefitsOfRegistration.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BenefitsOfRegistration.vue?vue&type=style&index=0&id=2dcb6e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb6e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcb6e96')) {
      api.createRecord('2dcb6e96', component.options)
    } else {
      api.reload('2dcb6e96', component.options)
    }
    module.hot.accept("./BenefitsOfRegistration.vue?vue&type=template&id=2dcb6e96&scoped=true&", function () {
      api.rerender('2dcb6e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/BenefitsOfRegistration.vue"
export default component.exports